export const toggleSection = () => {
  const btnToggleSection = ".js-section-toggle";
  const section = ".js-section";

  const init = () => {
    bind();
  };

  const bind = () => {
    $(btnToggleSection).on("click", function(e) {
      e.preventDefault();
      $(btnToggleSection).removeClass("is-active");
      $(this).addClass("is-active");
      let sectionToToggle = $(this).attr("data-section");
      $(section).removeClass("is-active");
      $(section + '[data-section="' + sectionToToggle + '"]').addClass("is-active");
    });
  };

  init();
};
